import React, { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../redux/component_select_report/actions'

// icon 
import { FaFileContract } from 'react-icons/fa'

// api 
import { getUserById } from '../../services/apis/UserAPIServices'

class ReportComponent extends Component{

    constructor(props){
        super(props)
        this.state = {
            display_name: "",
            avatar: ""
        }
    }

    _handleUpdateSelectReportState = () => {
        const { report } = this.props 
        this.props.updateSelectStateReport(report.fid, !report.isSelect)
    }

    componentWillReceiveProps = async (nextProps) => {
        if (this.props.report !== nextProps.report){
            try {
                let { report } = nextProps
                const response = await getUserById(report.owner_id)
    
                if (response.error.code === 200){
                    const user = response.data
                    this.setState({
                        display_name: user.display_name,
                        avatar: user.avatar
                    })
                }
            }
            catch {
    
            }
        }
    }

    componentDidMount = async() => {
        try {
            let { report } = this.props
            const response = await getUserById(report.owner_id)

            if (response.error.code === 200){
                const user = response.data
                this.setState({
                    display_name: user.display_name,
                    avatar: user.avatar
                })
            }
        }
        catch {

        }
    }

    render(){
        const { report } = this.props
        const { display_name, avatar } = this.state
        const { isSelect } = report
        const color = isSelect ? 'lightgreen' : 'white'

        return (
            <div className="ReportComponentContainer">
                <div className="ReportComponent" style={{backgroundColor: color, cursor: 'pointer'}}
                    onClick = {() => this._handleUpdateSelectReportState()}
                >
                    <FaFileContract />
                    {
                        report.title + " ( Do " + display_name + " tạo)"
                    }
                </div>
                
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {

    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateSelectStateReport: (fid, selectState) => {
            dispatch(ReportActions.action.updateSelectStateReport(fid, selectState))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportComponent)